module.exports = __webpack_public_path__ + "static/assets/0d7fd10d6285a8b523e17d424c07d35a.png";